// components/ui/VisibilityPill.js
import React from "react";
import { GlobeAltIcon, LockClosedIcon } from "@heroicons/react/24/outline";

export default function VisibilityPill({
  visibility,
  size = "sm",
  className = "",
  showLabel = true,
  interactive = false,
  onClick,
}) {
  const isPublic = visibility === "public";

  // Size variants
  const sizeClasses = {
    xs: "px-1.5 py-0.5 text-xs gap-0.5",
    sm: "px-2 py-0.5 text-xs gap-1",
    md: "px-4 py-1.5 text-sm gap-1",
    lg: "px-6 py-2 text-base gap-2",
  };

  // Icon sizes
  const iconSizes = {
    xs: "h-3 w-3",
    sm: "h-3.5 w-3.5",
    md: "h-4 w-4",
    lg: "h-5 w-5",
  };

  const baseClasses = "inline-flex items-center rounded-full ring-1";
  const colorClasses = isPublic
    ? "bg-primary text-text-inverse ring-primary-500"
    : "bg-surface-sunken text-text-secondary ring-border";

  const interactiveClasses = interactive
    ? "cursor-pointer hover:opacity-80 transition-opacity"
    : "";

  const combinedClasses = `
    ${baseClasses} 
    ${sizeClasses[size]} 
    ${colorClasses} 
    ${interactiveClasses} 
    ${className}
  `
    .trim()
    .replace(/\s+/g, " ");

  const content = (
    <>
      {isPublic ? (
        <GlobeAltIcon className={iconSizes[size]} />
      ) : (
        <LockClosedIcon className={iconSizes[size]} />
      )}
      {showLabel && (isPublic ? "Public" : "Private")}
    </>
  );

  if (interactive && onClick) {
    return (
      <button
        onClick={onClick}
        className={combinedClasses}
        title={isPublic ? "Public note" : "Private note"}
      >
        {content}
      </button>
    );
  }

  return (
    <span
      className={combinedClasses}
      title={isPublic ? "Public note" : "Private note"}
    >
      {content}
    </span>
  );
}
